let StudyListView = require("./view/StudyListView");
let DesignView = require("./view/DesignView");
let DeviceFormView = require("./view/DeviceFormView");
let LoginView = require("./view/LoginView");
let MetricDetailView = require("./view/MetricDetailView");
let MetricListView = require("./view/MetricListView");
let PasswordFormView = require("./view/PasswordFormView");
let RecordingView = require("./view/RecordingView");
let SubjectListView = require("./view/SubjectListView");
let SubjectMessagesView = require("./view/SubjectMessagesView");
let SubjectView = require("./view/SubjectView");
let UserListView = require("./view/UserListView");

let routes = [
  {
    id: "LOGIN_VIEW",
    path: "/login",
    view: LoginView,
    secure: false
  },
  {
    id: "RESET_PASSWORD_VIEW",
    path: "/users/:userId/resets/:resetId",
    view: PasswordFormView,
    secure: false
  },
  {
    id: "INVITE_VIEW",
    path: "/users/:userId/resets/:resetId/invite",
    view: PasswordFormView,
    secure: false
  },
  {
    id: "STUDY_LIST_VIEW",
    path: "/studies",
    view: StudyListView,
    secure: true
  },
  {
    id: "DESIGN_STUDY_VIEW",
    path: "/studies/:studyId/design",
    view: DesignView,
    secure: true
  },
  {
    id: "NEW_DEVICE_VIEW",
    path: "/studies/:studyId/design/device",
    view: DeviceFormView,
    secure: true
  },
  {
    id: "EDIT_DEVICE_VIEW",
    path: "/studies/:studyId/design/devices/:deviceConfigId",
    view: DeviceFormView,
    secure: true
  },
  {
    id: "SUBJECT_LIST_VIEW",
    path: "/studies/:studyId/subjects",
    view: SubjectListView,
    secure: true
  },
  {
    id: "SUBJECT_DETAIL_VIEW",
    path: "/studies/:studyId/subjects/:subjectId",
    view: SubjectView,
    secure: true
  },
  {
    id: "SUBJECT_MESSAGES_VIEW",
    path: "/studies/:studyId/subjects/:subjectId/messages",
    view: SubjectMessagesView,
    secure: true
  },
  {
    id: "RECORDING_DATA_VIEW",
    path: "/studies/:studyId/subjects/:subjectId/recordings/:startTs",
    view: RecordingView,
    secure: true
  },
  {
    id: "METRIC_LIST_VIEW",
    path: "/studies/:studyId/subjects/:subjectId/metrics",
    view: MetricListView,
    secure: true
  },
  {
    id: "METRIC_DETAIL_VIEW",
    path: "/studies/:studyId/subjects/:subjectId/metrics/:startTs",
    view: MetricDetailView,
    secure: true
  },
  {
    id: "USER_LIST_VIEW",
    path: "/users",
    view: UserListView,
    secure: true
  }
];

module.exports = routes;
